import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'


function WeddingPlanner({
    open,
	handleClose,
	handleNext,
	handleBack,
}) {
    const types = [
        { title: 'Yes', onClick: () => handleNext(2) },
        { title: 'No', onClick: () => handleNext(2) },
        { title: 'No - but we are looking for support', onClick: () => handleNext() },
    ]
    
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Do you have a wedding planner?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{types.map((type, idx) => (
									<ButtonCustom
										key={idx}
										data-cy={`${type.title}`}
										variant="pilled"
										onClick={type.onClick}
									>
										{type.title}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.3} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default WeddingPlanner
